export const SIGN_UP = '/sign-up';
export const SIGN_IN = '/sign-in';
export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forgotten';

export const RANDOM_EXAMPLE = '/example-random';
export const ADD_SNIPPET = '/add-snippet';
export const SNIPPETS = '/snippets';
